module.exports = "images/soundOff.7d6c3c26.png";